import { useStaticQuery, graphql } from "gatsby"

const PropertyImagePath = basename => {
  const result = useStaticQuery(
    graphql`
      query {
        allFile(filter: { internal: { mediaType: { regex: "/image/" } } }) {
          edges {
            node {
              relativePath
              childImageSharp {
                original {
                  src
                }
              }
            }
          }
        }
      }
    `
  )

  const image = result.allFile.edges.find(n => {
    return n.node.relativePath.includes(basename)
  })

  if (!image) {
    return null
  }

  // console.log(`[image path]${image.node.childImageSharp.original.src}`)
  return `${image.node.childImageSharp.original.src}`
}

export default PropertyImagePath
